<template>
    <a-layout>
        <a-layout-sider
            breakpoint="lg"
            collapsed-width="0"
            v-model:collapsed="isCollapsed"
            @breakpoint="onBreakpoint"
            :style="{ backgroundColor: 'transparent', position: (isBroken) ? 'absolute' : 'relative', zIndex: 1, }"
            width="300px"
        >
            <a-menu mode="inline" :openKeys="['admin', 'account', 'chargeCoin', 'tlbb']"
                :selectedKeys="[ (curRouteName as string) ]" theme="dark">
                <a-sub-menu v-if="hasModeratorPermission" key="admin">
                    <template #icon>
                        <NumberOutlined />
                    </template>
                    <template #title>{{ $t('text.administrator') }}</template>

                    <a-menu-item :key="RouteName.ARTICLE_LIST">
                        <router-link :to="{ name: RouteName.ARTICLE_LIST }">{{ $t('text.menuAdminArticle') }}
                        </router-link>
                    </a-menu-item>
                    <a-menu-item :key="RouteName.GIFTCODE_MANAGE">
                        <router-link :to="{ name: RouteName.GIFTCODE_MANAGE }">{{ $t('text.menuAdminGiftCode')
                            }}</router-link>
                    </a-menu-item>
                    <a-menu-item v-if="hasManagerPermission" :key="RouteName.COIN_CHARGE_MANAGE">
                        <router-link :to="{ name: RouteName.COIN_CHARGE_MANAGE }">{{
                            $t('text.menuAdminChargeCoin') }}</router-link>
                    </a-menu-item>
                    <a-menu-item v-if="hasManagerPermission" :key="RouteName.USER_LIST_MANAGER">
                        <router-link :to="{ name: RouteName.USER_LIST_MANAGER }">{{
                            $t('text.menuAdminMangeUser') }}</router-link>
                    </a-menu-item>
                    <a-menu-item v-if="hasManagerPermission" :key="RouteName.BILLING_PC_LOGGED_IN_GAME_MANAGE">
                        <router-link :to="{ name: RouteName.BILLING_PC_LOGGED_IN_GAME_MANAGE }">{{
                            $t('text.menuAdminPcLoginPermission') }}</router-link>
                    </a-menu-item>
                    <a-menu-item v-if="hasMasterAdminPermission" :key="RouteName.SITE_CONFIGURATION">
                        <router-link :to="{ name: RouteName.SITE_CONFIGURATION }">{{
                            $t('text.menuAdminSiteConfig') }}</router-link>
                    </a-menu-item>
                </a-sub-menu>

                <a-sub-menu key="account">
                    <template #icon>
                        <UserOutlined />
                    </template>
                    <template #title>{{ $t('text.account') }}</template>

                    <a-menu-item :key="RouteName.TOP">
                        <router-link :to="{ name: RouteName.TOP }">{{ $t('text.menuAccountManager') }}
                        </router-link>
                    </a-menu-item>
                </a-sub-menu>

                <a-sub-menu key="chargeCoin">
                    <template #icon>
                        <TransactionOutlined />
                    </template>
                    <template #title>{{ $t('text.chargeCoin') }}</template>

                    <a-menu-item :key="RouteName.PAYMENT_CHARGE_VIA_CRYPT_COIN">
                        <router-link :to="{ name: RouteName.PAYMENT_CHARGE_VIA_CRYPT_COIN }">{{
                            $t('text.menuPaymentChargeUseCryptCoin') }}</router-link>
                    </a-menu-item>
                    <a-menu-item v-if="hasManagerPermission" :key="RouteName.PAYMENT_CHARGE_VIA_EBANK">
                        <router-link :to="{ name: RouteName.PAYMENT_CHARGE_VIA_EBANK }">{{
                            $t('text.menuPaymentChargeUseBankTransfer') }}</router-link>
                    </a-menu-item>
                    <a-menu-item :key="RouteName.PAYMENT_CHARGE_VIA_CARD">
                        <router-link :to="{ name: RouteName.PAYMENT_CHARGE_VIA_CARD }">{{
                            $t('text.menuPaymentChargeUseCard') }}</router-link>
                    </a-menu-item>
                    <a-menu-item :key="RouteName.PAYMENT_HISTORY">
                        <router-link :to="{ name: RouteName.PAYMENT_HISTORY }">{{ $t('text.menuPaymentHistory')
                            }}</router-link>
                    </a-menu-item>
                </a-sub-menu>

                <a-sub-menu key="tlbb">
                    <template #icon>
                        <AimOutlined />
                    </template>
                    <template #title>{{ $t('text.tlbb') }}</template>

                    <a-menu-item :key="RouteName.PAYMENT_TRANSFER_TO_TLBB">
                        <router-link :to="{ name: RouteName.PAYMENT_TRANSFER_TO_TLBB }">{{
                            $t('text.menuTlbbTransferCoinToGame') }}</router-link>
                    </a-menu-item>
                    <a-menu-item :key="RouteName.CHAR_GAME_FUNC">
                        <router-link :to="{ name: RouteName.CHAR_GAME_FUNC }">{{ $t('text.menuTlbbCharFunc') }}
                        </router-link>
                    </a-menu-item>
                </a-sub-menu>
            </a-menu>
        </a-layout-sider>
        <a-layout-content :style="{ paddingLeft: (!isCollapsed && !isBroken) ? '10px' : '0' }">
            <router-view />
        </a-layout-content>
    </a-layout>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch, } from 'vue'
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import { Layout, Menu, message, } from 'ant-design-vue';
import {
    NumberOutlined, UserOutlined, TransactionOutlined, AimOutlined,
} from '@ant-design/icons-vue';

import { RouteName } from '@/router';
import { StoreType as UserStoreType } from '@/store/modules/user';

export default defineComponent({
    name: 'LoggedInLayout',

    components: {
        AMenu: Menu,
        AMenuItem: Menu.Item,
        ASubMenu: Menu.SubMenu,
        ALayout: Layout,
        ALayoutContent: Layout.Content,
        ALayoutSider: Layout.Sider,

        NumberOutlined,
        UserOutlined,
        TransactionOutlined,
        AimOutlined,
    },

    setup() {
        const router = useRouter();
        const store = useStore();
        const { t } = useI18n();

        const isCollapsed = ref(false);
        const isBroken = ref(false);

        const curRoute = router.currentRoute;

        const curRouteName = computed(() => curRoute.value.name);

        watch(() => curRouteName.value, (val)=> {
            if (val === RouteName.AUTH_PASSWORD2) {
                if (isBroken.value) {
                    isCollapsed.value = true;
                }
            }
        });

        onMounted(() => {
            const fetchUserMsgKey = 'fetchUser';
            const fetchMsgClose = message.loading({
                content: t('message.fetchingUser'),
                key: fetchUserMsgKey,
                duration: 0,
            });

            store.dispatch(UserStoreType.FETCH_USER)
                .then(() => {
                    message.success({
                        content: t('message.fetchUserSuccess'),
                        key: fetchUserMsgKey,
                        duration: 1.5,
                    });
                })
                .catch(() => {
                    fetchMsgClose();
                });
        });

        const onBreakpoint = (broken: boolean) => {
            isBroken.value = broken;
        };

        return {
            hasModeratorPermission: computed<boolean>(() => store.getters.hasModeratorPermission),
            hasManagerPermission: computed<boolean>(() => store.getters.hasManagerPermission),
            hasMasterAdminPermission: computed<boolean>(() => store.getters.hasMasterAdminPermission),

            curRouteName,

            onBreakpoint,
            isCollapsed,
            isBroken,

            RouteName,
        };
    },
})
</script>

<style scoped>
</style>
